<template>
    <hts-router-drawer
        :title="$t('labels.editInvoicingInformation')"
        :size="50"
        :submit="submit"
        is-close
        :rules="rulesInvoicingInformation"
        @loaded="getData"
        @refresh-tables="refreshTables">
        <hts-card :title="$t('labels.generalInformation')">
            <hts-form-input
                v-model="formData.companyName"
                :label="$t('labels.companyName')"
                required
                prop="companyName"
                name="companyName" />

            <hts-form-input
                v-model="formData.phone"
                :label="$t('labels.phone')"
                prop="phone"
                name="phone" />

            <hts-form-input
                v-model="formData.address"
                :label="$t('labels.address')"
                prop="address"
                name="address" />

            <hts-form-input
                v-model="formData.email"
                :label="$t('labels.email')"
                prop="email"
                name="email" />

            <hts-form-input
                v-model="formData.taxNumber"
                :label="$t('labels.taxNumber')"
                prop="taxNumber"
                name="taxNumber" />

            <hts-form-input
                v-model="formData.contactName"
                :label="$t('labels.contactName')"
                prop="contactName"
                name="contactName" />
        </hts-card>
    </hts-router-drawer>
</template>

<script setup lang="ts">
import data from '../ignore/data'
const { departments } = data()

const rulesInvoicingInformation = {
  companyName: 'required'
}

const cooperatorId = computed(() => useRoute().params.idpartner)
const cooperatorInvoicingInformationtId = computed(() => useRoute().params.idinvoicinginformation)

const loading = ref(false)
const props = defineProps({
  color: {
    type: String,
    default: 'theme'
  }
})

const formData = reactive({
  companyName: '',
  phone: '',
  address: '',
  email: '',
  taxNumber: '',
  contactName: ''
})

const emits = defineEmits(['refreshTables'])

const refreshTables = () => {
  emits('refreshTables')
}

const submit = async () => {
  const api = {
    url: '/partner/invoicing-information/cooperatorId/update/cooperatorInvoicingInformationtId',
    method: 'put'
  }
  const data: any = await $api(api, {
    uriParams: {
      cooperatorId: cooperatorId.value,
      cooperatorInvoicingInformationtId: cooperatorInvoicingInformationtId.value
    },
    body: formData
  })
  const resData = data?.data?.value
  if (resData?.success) {
    process.client && $toast().success($t('labels.editInvoicingInformationSuccess'))
    close()
    emits('refreshTables')
  }
}

const getData = () => {
  const api = {
    url: '/partner/invoicing-information/cooperatorId/detail/cooperatorInvoicingInformationtId',
    method: 'get'
  }
  $api(api, {
    uriParams: {
      cooperatorId: cooperatorId.value,
      cooperatorInvoicingInformationtId: cooperatorInvoicingInformationtId.value
    }
  }).then((data: any) => {
    const resData: any = data.data.value
    if (resData?.success) {
      loading.value = true
      Object.assign(formData, {
        companyName: resData.data.companyName || '',
        phone: resData.data.phone || '',
        address: resData.data.address || '',
        email: resData.data.email || '',
        taxNumber: resData.data.taxNumber || '',
        contactName: resData.data.contactName || ''
      })
    }
  })
}
</script>
